import React from "react";
import { Modal, Button } from "react-bootstrap";
import styled, { css } from "styled-components";
import ConfirmBtn from '../Button'


const Wrapper = styled.div`
  position: relative;
  padding: 30px;
  text-align: center;
  font-family: "Noto Sans Thai", sans-serif;

  /* ✅ mobile */
  @media (max-width: 768px) {
    padding: 24px 16px 16px 16px;
  }
`;

const Handle = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block;
    height: 1px;
    background: #D6D8DA;
    border-radius: 999px;
    margin: 0 auto 16px;
  }
  
`;

const Close = styled.span`
  position: absolute;
  right: 16px;
  top: 16px;
  font-size: 30px;
  font-weight: 600;
  cursor: pointer;
`;

const Icon = styled.div`
  img {
    width: 144px;
    height: 144px;

    @media (max-width: 768px) {
      width: 96px;
      height: 96px;
    }
  }
`;

const Title = styled.div`
  font-size: 26px;
  font-weight: 600;
  line-height: 42px;
  margin: 5px 0 12px 0;
  white-space: pre-line;

  @media (max-width: 768px) {
    font-size: 22px;
    line-height: 34px;
  }
`;

const Desc = styled.div`
  font-size: 16px;
  font-weight: 400;
  white-space: pre-line;
  line-height: 24px;
`;

const Content = styled.div`
  font-size: 14px;
`;

const Footer = styled.div`
  margin: 12px 0 0 0;
`;

// const ConfirmBtn = styled(Button)`
//   font-family: "Noto Sans Thai", sans-serif;
//   width: 100%;
//   height: 44px;
//   background: #d93a49;
//   border: none;
//   border-radius: 6px;
//   font-size: 16px;

//   &:hover {
//     background: #c5323f;
//   }

//   &:focus,
//   &:focus-visible {
//     outline: none;
//     box-shadow: none;
//     backgrond: #d93a49 !important;
//   }
// `;

const StyledModal = styled(Modal)`
  font-family: "Noto Sans Thai", sans-serif;
  font-weight: 500;
  color: #14181C;

  .modal-content {
    border-radius: 16px;
    border: none;
  }

  .modal-dialog {
    min-width: 288px;

    @media (max-width: 768px) {
      // max-width: 90%;
      margin: 0 36px;
    }
  }

  @media (max-width: 768px) {
    ${({ $isBottomSheet }) =>
      $isBottomSheet &&
      css`

        .modal-dialog {
          margin: 0;
          height: 100%;
        }

        .modal-dialog-centered {
          align-items: flex-end;
        }

        ${Title} {
          display: flex;
          justify-content: center;
        }

        ${Close} {
          top: 8px;
        }

    `}
  }

  
`;

const ExampleStyle = css`
  text-align: left;
  padding: 16px;

  ${Content} .sub-title-bold {
    margin-bottom: 10px;
    font-weight: 600;
    font-size: 16px;
  }

  ${Content} img {
    width: 100%;
    border-radius: 8px;
    margin-top: 12px;
  }
`;

const TextStyle = css`
  text-align: left;
  padding: 16px;

  ${Content} {
    max-height: 200px;
    overflow-y: auto;

    display: flex;
    flex-direction: column;
  }
  ${Content} .sub-title-bold {
    margin-bottom: 10px;
    font-weight: 600;
  }

  ${Content} .highlight {
    text-decoration: underline;
    text-decoration-color: #14181C;
    text-decoration-thickness: 1px;
    margin-top: 3px;
  }
`;

const getTypeStyle = (type) => {
  switch (type) {
    case "example":
      return ExampleStyle;
    case "text":
      return TextStyle;
    default:
      return "";
  }
};

const bottomSheetMap = ['example', 'text']

const CommonModal = ({
  show,
  showCloseBtn = true,
  onHide,
  icon,
  title,
  desc,
  type,
  children,
  confirmText = "ตกลง",
  onConfirm,
  showFooter = true,
}) => {
  return (
    <StyledModal
      show={show}
      onHide={onHide}
      backdrop="static"
      centered
      dialogClassName="custom-dialog"
      $isBottomSheet={bottomSheetMap.includes(type)}
    >
      <ModalBody type={type}>
        {showCloseBtn && <Close onClick={onHide}>×</Close>}

        {icon && <Icon><img src={icon} alt="icon"/></Icon>}

        {title && <Title>{title}</Title>}

        {bottomSheetMap.includes(type) && <Handle />}

        {desc && <Desc>{desc}</Desc>}

        <Content>{children}</Content>

        {showFooter && (
          <Footer>
            <ConfirmBtn onClick={onConfirm || onHide}>
              {confirmText}
            </ConfirmBtn>
          </Footer>
        )}
      </ModalBody>
    </StyledModal>
  );
};

const ModalBody = styled(Wrapper)`
  ${(props) => getTypeStyle(props.type)}
`;

export default CommonModal;